export const MARGIN = 15
export const DEAFAULT_DURATION = 5000
export const ANIMATION_TIMER = 200
